import apiClient from "./api/apiClient";

const settingsService = {
  getAccount: async () => apiClient.get("/settings/account"),
  updateAccount: async (payload) => apiClient.put("/settings/account", payload),
  updatePreferences: async (payload) => apiClient.put("/settings/preferences", payload),
  getActivity: async () => apiClient.get("/settings/activity"),
  getSecurity: async () => apiClient.get("/settings/security"),
  getSecurityDataOverview: async () => apiClient.get("/settings/security/data-overview"),
  getDefaults: async () => apiClient.get("/settings/defaults"),
  updateDefaults: async (payload) => apiClient.put("/settings/defaults", payload),
  resetDefaults: async (section = "all") => apiClient.post("/settings/defaults/reset", { section }),
  revokeOtherSessions: async () => apiClient.delete("/settings/sessions"),
  revokeSession: async (sessionId) => apiClient.delete(`/settings/sessions/${sessionId}`),
  changePassword: async (payload) => apiClient.post("/settings/password", payload),
  requestDataExport: async () => apiClient.post("/settings/data-export", {}),
  deactivateAccount: async () => apiClient.post("/settings/deactivate", {}),
  deleteAccount: async () => apiClient.delete("/settings/account"),
};

export default settingsService;
